export const SET_IS_COLLAPSED = 'SET_IS_COLLAPSED';
export const UI_SHOW_GUIDING_MODAL = 'UI_SHOW_GUIDING_MODAL';
